import React from 'react';
import {
  Button, Modal, ModalProps,
} from 'react-bootstrap';
// @ts-ignore
import styles from '../physician.module.scss';

interface MQAResultModalProps extends ModalProps {

}

export function MQAResultModal(props: MQAResultModalProps) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size={props.size}
      aria-labelledby={props.label}
      centered={props.centered}
      backdrop={props.static}
      animation={props.animation}
      className={props.className}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{props.subTitle}</p>
          <textarea
            className={styles.mqaResultModalBody}
            value={props.data}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="k-button text-center"
          variant="primary"
          onClick={props.onHide}
        >
          {props.buttontext}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
